import React from "react";
import {DatePicker, Form, FormInstance, Input, message} from "antd";
import locale from "antd/es/date-picker/locale/zh_CN";
import AuthGroupTree from "./auth-group-tree";
import {ApiUser} from "../../domains/api-user";
import moment from 'moment';
import {getTimeString, request} from "../../utils/utils";

interface ApiUserEditProps {
    onEditSuccess: () => void,
}

interface ApiUserEditState {
    user?: ApiUser
}

export default class ApiUserEdit extends React.Component<ApiUserEditProps, ApiUserEditState> {
    constructor(props: Readonly<ApiUserEditProps> | ApiUserEditProps) {
        super(props);
        this.state = {}
    }

    layout = {
        labelCol: {span: 4},
        wrapperCol: {span: 18}
    };
    formRef = React.createRef<FormInstance>()
    authGroupTreeSelect = React.createRef<AuthGroupTree>()


    submitForm = () => {
        this.formRef.current!.submit()
    }

    fillUpForm = (entity: ApiUser) => {
        if (entity) {
            // let timeString = getTimeString(new Date(entity.validateTime || '0'))
            debugger
            this.formRef.current!.setFieldsValue({
                appName: entity.appName,
                customerName: entity.customerName,
                validateTime: moment(getTimeString(new Date(entity.validateTime || '0')), 'YYYY/MM/DD')
            })
            this.authGroupTreeSelect.current!.updateTreeIds(entity.authGroupList)
            this.setState({user: entity})
        }
    }

    clearForm = () => {
        this.formRef.current!.resetFields()
    }

    private handleFormSubmit = (value: any) => {
        let selectedValue = this.authGroupTreeSelect.current!.state.selectedValue
        let form = new FormData()
        form.append("appName", value.appName)
        form.append("cusName", value.customerName)
        form.append("authGroupList", selectedValue.join(","))
        form.append("validateTime", value.validateTime)
        if (!this.state.user) {
            request({
                method: "POST",
                url: "/gateway/apiuser/generate",
                data: form,
                headers: {'ContentType': 'application/x-www-form-urlencoded;'}
            }).then((res) => {
                message.info("编辑成功")
                this.props.onEditSuccess()
            }).catch(res => {
                message.info("路由配置失败，请稍后重试" + res)
            })
        } else {
            form.append("id", this.state.user.apiUserId)
            request({
                method: "POST",
                url: "/gateway/apiuser/update",
                data: form,
                headers: {'ContentType': 'application/x-www-form-urlencoded;'}
            }).then((res) => {
                message.info("编辑成功")
                this.props.onEditSuccess()
            }).catch(res => {
                message.info("路由配置失败，请稍后重试" + res)
            })
        }
    }

    render() {
        return (
            <Form
                {...this.layout}
                ref={this.formRef}
                onFinish={this.handleFormSubmit}
            >
                <Form.Item label={"应用名称"} name={"appName"}>
                    <Input/>
                </Form.Item>
                <Form.Item label={"客户名称"} name={"customerName"}>
                    <Input/>
                </Form.Item>
                <Form.Item label={"有效期"} name={"validateTime"}>
                    <DatePicker locale={locale}
                                value={moment(getTimeString(new Date(this.state.user?.validateTime || '0')), 'YYYY/MM/DD')}/>
                </Form.Item>
                <Form.Item label={"授权组"} name={"grantedAuthGroup"}>
                    <AuthGroupTree
                        ref={this.authGroupTreeSelect}
                        treeSelect={true} treeCheckable={false}/>
                </Form.Item>
            </Form>
        )
    }
}
